module.exports = __webpack_public_path__ + "img/chr_ts_23.e08ff5b0.png";